import {getDatabase, ref} from "firebase/database";
import {firebase} from "../firebase";

export const EMPTY_GUEST = {
    name: '',
    mail: '',
    site: '',
    invitations: 1,
    promiseNames: [],
    taxi: {
        feedback: '',
        selected: 'empty'
    },
    refusal: false
}

export const EMPTY_PERSON = {
    fullName: '',
    marriage: false,
    agape: false,
    dinner: false,
    party: false,
    child: false,
    baby: false,
    maybe: false,
}

export const EMPTY_MEAL = {
    name: '',
    child: false,
    age: 0,
    chair: false,
    selectedCourses: null
}

export const CHECK_LIST = ['party', 'marriage', 'agape', 'dinner', 'baby', 'child', 'maybe'];

export const mealText = {
    soupOne: 'Hochzeitssuppe mit Grießnockerl, Leberknödel und/oder Frittaten mit frischem Schnittlauch',
    SoupTwo : 'Pikante Spitzpaprikacremesuppe mit Zitronen-Thymianschaum',
    mainOne: 'Wiener Schnitzel mit Petersilienkartoffeln, Preiselbeeren und Ketchup dazu ein Salatteller mit Gurken, Karotten, Tomaten und Vogerlsalat',
    mainTwo: 'Steirische Hühnerbrust mit Mozzarella und Basilikum gefüllt auf Safran-Risotto dazu Rosmarinsauce ',
    mainThree: 'Safran-Risotto dazu Pepperonata und Kräutersalat ',
    "" : 'Keine Auswahl'
}

const db = getDatabase(firebase);
export const GUEST_LIST_REF = db ? ref(db, 'guests'): null;
export const GALLERY_REF = db ?ref(db, 'gallery'): null;
export const CONFIG_REF = db ?ref(db, 'config'): null;
